(function () {
    'use strict';

    let currentScope = 'all';
    let lastQuery = '';
    let predictiveSearchInstances = [];
    const standaloneDropdownFetchers = [];

    function i18n(key) {
        return (window.SK && window.SK.i18n && window.SK.i18n[key]) || key;
    }

    function getCurrentCollection() {
        const m = window.location.pathname.match(/\/collections\/([^/?#]+)/);
        if (m) return m[1];
        if (window.SK && window.SK.productMainCollection) return window.SK.productMainCollection;
        return '';
    }

    function isApiReady() {
        return !!(window.SK && window.SK.machineSearchUrl);
    }

    const _escapeDiv = document.createElement('div');

    function escapeHtml(str) {
        _escapeDiv.textContent = String(str || '');
        return _escapeDiv.innerHTML;
    }

    function shopifyImgUrl(url, width) {
        if (!url) return url;
        return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + width;
    }

    const LOADING_SPINNER = '<div class="sk-search-loading">' +
        '<svg aria-hidden="true" focusable="false" role="presentation" class="spinner" ' +
        'style="width: 32px; height: 32px; color: var(--color-outlines);" ' +
        'viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">' +
        '<circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle>' +
        '</svg></div>';

    function createSpinnerSvg() {
        const svgNS = 'http://www.w3.org/2000/svg';
        const svg = document.createElementNS(svgNS, 'svg');
        svg.setAttribute('aria-hidden', 'true');
        svg.setAttribute('focusable', 'false');
        svg.setAttribute('role', 'presentation');
        svg.setAttribute('class', 'spinner');
        svg.setAttribute('style', 'width:32px;height:32px;color:var(--color-outlines)');
        svg.setAttribute('viewBox', '0 0 66 66');
        const circle = document.createElementNS(svgNS, 'circle');
        circle.setAttribute('class', 'path');
        circle.setAttribute('fill', 'none');
        circle.setAttribute('stroke-width', '6');
        circle.setAttribute('cx', '33');
        circle.setAttribute('cy', '33');
        circle.setAttribute('r', '30');
        svg.appendChild(circle);
        return svg;
    }

    function showLoadingOverlay(container) {
        const results = container.querySelector('#predictive-search-results');
        if (!results) return;
        results.style.minHeight = results.offsetHeight + 'px';
        if (results.querySelector('.sk-search-loading-overlay')) return;
        const overlay = document.createElement('div');
        overlay.className = 'sk-search-loading-overlay';
        overlay.appendChild(createSpinnerSvg());
        results.appendChild(overlay);
    }

    function applyResultsWithTransition(container, newMarkup) {
        const oldResults = container.querySelector('#predictive-search-results');
        const prevHeight = oldResults ? oldResults.offsetHeight : 0;

        container.textContent = '';
        const temp = document.createElement('div');
        temp.innerHTML = newMarkup;
        while (temp.firstChild) container.appendChild(temp.firstChild);

        const newResults = container.querySelector('#predictive-search-results');
        if (!newResults || !prevHeight) return;

        newResults.style.minHeight = prevHeight + 'px';
        newResults.style.transition = 'min-height 0.25s ease';
        requestAnimationFrame(function () {
            newResults.style.minHeight = '';
            newResults.addEventListener('transitionend', function handler() {
                newResults.style.transition = '';
                newResults.removeEventListener('transitionend', handler);
            }, {once: true});
        });
    }

    const FORKLIFT_SVG = '<svg aria-hidden="true" width="164" height="126" viewBox="0 0 164 126" fill="none" xmlns="http://www.w3.org/2000/svg">' +
        '<g clip-path="url(#clip0_1006_5761)">' +
        '<path d="M154 101L154 64H133H112L112 101H154Z" fill="#F16A62" fill-opacity="0.24" stroke="#F16A62" stroke-width="2"/>' +
        '<path d="M125 72V65H140V72L132.5 71.5L125 72Z" fill="white"/>' +
        '<path d="M27.9805 32.6924V52.3358H40.2576V37.6032C40.2576 36.2471 41.357 35.1478 42.7131 35.1478H63.4979C64.3189 35.1478 65.0855 35.5581 65.5409 36.2412L67.2107 38.7459C72.0509 46.0061 74.6337 54.5367 74.6337 63.2624V71.9793H86.9109V67.078C86.9109 54.2518 83.1904 41.701 76.2003 30.947L73.8554 27.3396C72.0437 24.5523 68.9449 22.8706 65.6205 22.8706H37.8022C32.3778 22.8706 27.9805 27.268 27.9805 32.6924Z" fill="#004894" fill-opacity="0.24"/>' +
        '<path d="M110.238 114.949V89.1674L100.314 71.9793H86.9109M52.5348 71.9793H74.6337M86.9109 71.9793V67.078C86.9109 54.2518 83.1904 41.701 76.2003 30.947L73.8554 27.3396C72.0437 24.5523 68.9449 22.8706 65.6205 22.8706H37.8022C32.3778 22.8706 27.9805 27.268 27.9805 32.6924V52.3358H40.2576V37.6032C40.2576 36.2471 41.357 35.1478 42.7131 35.1478H63.4979C64.3189 35.1478 65.0855 35.5581 65.5409 36.2412L67.2107 38.7459C72.0509 46.0061 74.6337 54.5367 74.6337 63.2624V71.9793M86.9109 71.9793H74.6337" stroke="#005DBF" stroke-width="2"/>' +
        '<path d="M5.88281 77.2228L5.88285 59.7032C5.88285 55.6349 9.18086 52.3369 13.2491 52.3369H39.6793C41.5394 52.3369 43.2399 53.3879 44.0717 55.0516L52.5361 71.9804H79.5459H91.8231H100.315L110.239 89.1684L110.897 112.495H20.4711C19.3986 112.495 18.3555 112.144 17.5013 111.495L9.76504 105.621C7.31924 103.764 5.88285 100.87 5.88284 97.7988L5.88281 89.5M5.88281 77.2228H12C14.2091 77.2228 16 79.0137 16 81.2228V85.5C16 87.7091 14.2091 89.5 12 89.5H5.88281M5.88281 77.2228V89.5" stroke="#005DBF" stroke-width="2"/>' +
        '<path d="M15.1104 71.3603H23.4569C23.6586 71.3454 23.8588 71.3137 24.0553 71.2655C24.4998 71.1406 24.8886 70.8676 25.1577 70.4914C25.4049 70.1639 25.5623 69.7772 25.6144 69.3698C25.6724 68.9988 25.6988 68.6236 25.6931 68.2481C25.6931 68.0586 25.6931 67.8532 25.6774 67.6162C25.6613 67.3879 25.6298 67.1609 25.5829 66.9369C25.5351 66.6958 25.4557 66.462 25.3467 66.2418C25.2351 66.0218 25.0918 65.8196 24.9215 65.6415C24.7033 65.427 24.4468 65.2555 24.1656 65.136C23.9022 65.0154 23.628 64.9201 23.3467 64.8516L19.5514 63.8247C19.3308 63.7677 19.115 63.6937 18.9057 63.6036C18.8168 63.5824 18.7375 63.5321 18.6804 63.4605C18.6234 63.3889 18.5918 63.3003 18.5907 63.2086C18.5886 63.1617 18.596 63.1148 18.6125 63.0708C18.6289 63.0268 18.6541 62.9866 18.6865 62.9526C18.7189 62.9186 18.7578 62.8916 18.8009 62.8732C18.844 62.8547 18.8903 62.8452 18.9372 62.8453H25.9766V60.0017H17.6459C17.2357 59.9876 16.8273 60.0631 16.449 60.2228C16.1785 60.3466 15.9287 60.5118 15.7088 60.7126C15.3961 61.0135 15.1865 61.4062 15.1104 61.8342C15.0347 62.2139 14.9978 62.6003 15.0002 62.9875C14.9971 63.427 15.034 63.8659 15.1104 64.2987C15.1718 64.7408 15.3453 65.1596 15.6144 65.5151C15.7526 65.7012 15.9171 65.8661 16.1025 66.0048C16.3456 66.1782 16.6176 66.3066 16.9057 66.384L21.2837 67.6162C21.4574 67.6628 21.6262 67.7263 21.7876 67.8058C21.8619 67.8357 21.9249 67.8886 21.9674 67.9567C22.0098 68.0249 22.0296 68.1048 22.0238 68.185C22.0195 68.2309 22.0062 68.2755 21.9846 68.3161C21.9629 68.3568 21.9335 68.3928 21.8978 68.4219C21.8348 68.5009 21.6616 68.5325 21.3939 68.5325H15.1104V71.3603Z" fill="#005DBF"/>' +
        '<path d="M30.6855 62.8293H31.4257L33.4257 60.0015H30.6855V62.8293Z" fill="#939598"/>' +
        '<path d="M26.4961 71.3601H30.1496V60.0015H26.4961V71.3601Z" fill="#005DBF"/>' +
        '<path d="M39.0007 71.3601L34.607 66.5576C34.4336 66.3887 34.2992 66.1838 34.2133 65.9573C34.1629 65.8097 34.1364 65.6551 34.1345 65.4991C34.1335 65.3447 34.1714 65.1926 34.2447 65.0568C34.3089 64.9302 34.3826 64.8087 34.4652 64.6934L38.4022 60.0015H34.0715L31.0321 64.2827C30.9114 64.4614 30.8209 64.6589 30.7644 64.8672C30.7022 65.0829 30.6704 65.3062 30.6699 65.5307C30.6682 66.0538 30.8461 66.5615 31.1739 66.9683L34.607 71.3601H39.0007Z" fill="#005DBF"/>' +
        '<path d="M100 2V93H110V2H100Z" fill="white"/>' +
        '<path d="M155.685 110.039H110.238V103H150.589C150.852 103 151.105 103.104 151.292 103.289L156.388 108.328C157.024 108.956 156.579 110.039 155.685 110.039Z" fill="white"/>' +
        '<path d="M100 2V93H110V2H100Z" stroke="#005DBF" stroke-width="2"/>' +
        '<path d="M155.685 110.039H110.238V103H150.589C150.852 103 151.105 103.104 151.292 103.289L156.388 108.328C157.024 108.956 156.579 110.039 155.685 110.039Z" stroke="#005DBF" stroke-width="2"/>' +
        '<path d="M40.2588 82.8022C51.9113 82.8022 61.3582 92.2484 61.3584 103.901C61.3584 115.553 51.9114 125 40.2588 125C28.6063 125 19.1602 115.553 19.1602 103.901C19.1603 92.2485 28.6064 82.8024 40.2588 82.8022Z" fill="white"/>' +
        '<path d="M40.2588 82.8022C51.9113 82.8022 61.3582 92.2484 61.3584 103.901C61.3584 115.553 51.9114 125 40.2588 125C28.6063 125 19.1602 115.553 19.1602 103.901C19.1603 92.2485 28.6064 82.8024 40.2588 82.8022Z" fill="#004894" fill-opacity="0.24"/>' +
        '<path d="M40.2588 82.8022C51.9113 82.8022 61.3582 92.2484 61.3584 103.901C61.3584 115.553 51.9114 125 40.2588 125C28.6063 125 19.1602 115.553 19.1602 103.901C19.1603 92.2485 28.6064 82.8024 40.2588 82.8022Z" stroke="#005DBF" stroke-width="2"/>' +
        '<circle cx="40.2573" cy="103.9" r="8.82174" fill="white" stroke="#005DBF" stroke-width="2"/>' +
        '<path d="M96.7334 82.8022C108.386 82.8022 117.833 92.2484 117.833 103.901C117.833 115.553 108.386 125 96.7334 125C85.0809 125 75.6348 115.553 75.6348 103.901C75.6349 92.2485 85.081 82.8024 96.7334 82.8022Z" fill="white"/>' +
        '<path d="M96.7334 82.8022C108.386 82.8022 117.833 92.2484 117.833 103.901C117.833 115.553 108.386 125 96.7334 125C85.0809 125 75.6348 115.553 75.6348 103.901C75.6349 92.2485 85.081 82.8024 96.7334 82.8022Z" fill="#004894" fill-opacity="0.24"/>' +
        '<path d="M96.7334 82.8022C108.386 82.8022 117.833 92.2484 117.833 103.901C117.833 115.553 108.386 125 96.7334 125C85.0809 125 75.6348 115.553 75.6348 103.901C75.6349 92.2485 85.081 82.8024 96.7334 82.8022Z" stroke="#005DBF" stroke-width="2"/>' +
        '<circle cx="96.7338" cy="103.9" r="8.82174" fill="white" stroke="#005DBF" stroke-width="2"/>' +
        '<path d="M125 64V73L132.5 71.5L140 73V64" stroke="#F16A62" stroke-width="2"/>' +
        '</g>' +
        '<defs><clipPath id="clip0_1006_5761"><rect width="164" height="126" fill="white"/></clipPath></defs>' +
        '</svg>';

    function buildSearchUrl(query) {
        try {
            const u = new URL(window.SK.machineSearchUrl, window.location.origin);
            u.pathname = u.pathname.replace(/\/+$/, '').replace(/[^/]+$/, 'search');
            u.search = '';
            u.searchParams.set('query', query);
            u.searchParams.set('first', String((window.SK && window.SK.searchDropdownFirst) || 8));
            u.searchParams.set('limit', String((window.SK && window.SK.searchDropdownLimit) || 6));
            const col = getCurrentCollection();
            if (currentScope === 'collection' && col) {
                u.searchParams.set('collection', col);
            }
            const locale = window.SK && window.SK.locale;
            if (locale) u.searchParams.set('locale', locale);
            return u.toString();
        } catch (e) {
            console.error('[SK Search] Failed to build search URL:', e);
            return null;
        }
    }


    function buildResultsPageUrl(query) {
        const root = ((window.routes && window.routes.root) || '').replace(/\/$/, '');
        let url = root + '/pages/machine-search?query=' + encodeURIComponent(query);
        const col = getCurrentCollection();
        if (currentScope === 'collection' && col) {
            url += '&collection=' + encodeURIComponent(col);
        }
        return url;
    }


    function fetchSearchData(query, signal) {
        const url = buildSearchUrl(query);
        if (!url) return Promise.reject(new Error('Cannot build search URL'));

        const opts = signal ? {signal: signal} : {};
        return fetch(url, opts)
            .then(function (r) {
                if (!r.ok) throw new Error('API error ' + r.status);
                return r.json();
            })
            .then(function (data) {
                return {
                    collections: data.collections || [],
                    products: data.products || [],
                    total: typeof data.total === 'number' ? data.total : (data.products || []).length,
                };
            });
    }


    function isPartNumberQuery(query, total, productsCount) {
        return /^\d+$/.test(query.trim()) && total === 1 && productsCount === 1;
    }

    function filterMetafields(metafields, metafieldLabels, limit) {
        if (!metafields) return [];
        const result = [];
        const keys = Object.keys(metafields);
        const i18nMf = window.SK && window.SK.i18n && window.SK.i18n.productMetafields;
        const excludeKeys = (window.SK && window.SK.productAttributesExcludeKeys) || [];
        for (let i = 0; i < keys.length && result.length < limit; i++) {
            const key = keys[i];
            if (key.indexOf('shopify--discovery') !== -1) continue;
            const strVal = String(metafields[key] || '').trim();
            if (strVal.charAt(0) === '[') continue;
            const bareKey = key.split('.').pop();
            if (excludeKeys.indexOf(bareKey) !== -1) continue;
            const label = (i18nMf && i18nMf[bareKey]) ||
                (metafieldLabels && metafieldLabels[key]) ||
                bareKey.replace(/_/g, ' ');
            if (!label) continue;
            result.push({label: label, value: metafields[key]});
        }
        return result;
    }

    function buildCategoryItem(c) {
        const imgHtml = c.imageUrl
            ? '<img class="sk-search-category__img" src="' + escapeHtml(shopifyImgUrl(c.imageUrl, 72)) +
            '" alt="' + escapeHtml(c.imageAlt || c.title) + '" width="36" height="24" loading="lazy">'
            : '';
        const count = typeof c.productCount === 'number' ? c.productCount : 0;
        const countStyle = c.primaryColor
            ? ' style="color: var(' + escapeHtml(c.primaryColor) + ')"'
            : '';
        return '<li class="sk-search-category__item">' +
            '<a href="' + escapeHtml(c.url) + '" class="sk-search-category__link">' +
            '<span class="sk-search-category__link-info">' +
            imgHtml +
            '<span class="sk-search-category__name">' + escapeHtml(c.title) + '</span>' +
            '</span>' +
            '<span class="sk-search-category__count"' + countStyle + '>' + count + ' ' + i18n('products') + '</span>' +
            '</a></li>';
    }

    function buildCompactProductCard(p, index) {
        const imgHtml = (p.featuredImage && p.featuredImage.url)
            ? '<img class="predictive-search__image"' +
            ' src="' + escapeHtml(shopifyImgUrl(p.featuredImage.url, 120)) + '"' +
            ' srcset="' + escapeHtml(shopifyImgUrl(p.featuredImage.url, 60)) + ' 60w, ' +
                          escapeHtml(shopifyImgUrl(p.featuredImage.url, 120)) + ' 120w"' +
            ' sizes="60px"' +
            ' alt="' + escapeHtml(p.title) + '" width="60" height="40" loading="lazy">'
            : '<div class="predictive-search__image sk-search-product__no-img"></div>';

        const metaParts = [];
        if (p.machine && p.machine.model) {
            const modelLabel = (window.SK && window.SK.i18n && window.SK.i18n.machineModel) || '';
            metaParts.push('<span>' + (modelLabel ? escapeHtml(modelLabel) + ': ' : '') + escapeHtml(p.machine.model) + '</span>');
        }
        if (p.partNumber) {
            const pnStyle = p.collectionPrimaryColor
                ? ' style="color: var(' + escapeHtml(p.collectionPrimaryColor) + ')"'
                : '';
            metaParts.push('<span class="predictive-search__item-part-number"' + pnStyle + '>' + i18n('partNumber') + ': ' + escapeHtml(p.partNumber) + '</span>');
        }
        const metaHtml = metaParts.length > 0
            ? '<p class="predictive-search__item-meta">' + metaParts.join('') + '</p>'
            : '';

        const productUrl = p.url || ('/products/' + p.handle);
        return '<li id="predictive-search-option-product-' + (index + 1) + '"' +
            ' class="predictive-search__list-item" role="option" aria-selected="false">' +
            '<a href="' + escapeHtml(productUrl) + '"' +
            ' class="predictive-search__item predictive-search__item--link-with-thumbnail" tabindex="-1">' +
            imgHtml +
            '<div class="predictive-search__item-content">' +
            '<p>' + escapeHtml(p.title) + '</p>' +
            metaHtml +
            '</div></a></li>';
    }

    function buildPartNumberCard(p) {
        const productUrl = p.url || ('/products/' + p.handle);
        const imgHtml = (p.featuredImage && p.featuredImage.url)
            ? '<img width="96" height="64"' +
            ' src="' + escapeHtml(shopifyImgUrl(p.featuredImage.url, 192)) + '"' +
            ' srcset="' + escapeHtml(shopifyImgUrl(p.featuredImage.url, 96)) + ' 96w, ' +
                          escapeHtml(shopifyImgUrl(p.featuredImage.url, 192)) + ' 192w"' +
            ' sizes="96px"' +
            ' alt="' + escapeHtml(p.title) + '" loading="lazy">'
            : '';

        const specs = filterMetafields(p.metafields, p.metafieldLabels, 2);
        let specsHtml = '';
        if (specs.length > 0) {
            specsHtml = '<div class="sk-search-detail-card__divider"></div>' +
                '<div class="sk-search-detail-card__specs">' +
                specs.map(function (s) {
                    return '<div class="sk-search-detail-card__spec">' +
                        '<span class="sk-search-detail-card__spec-label">' + escapeHtml(s.label) + ':</span>' +
                        '<span class="sk-search-detail-card__spec-value">' + escapeHtml(s.value) + '</span>' +
                        '</div>';
                }).join('') +
                '</div>';
        }

        return '<div class="sk-search-detail-card">' +
            '<a href="' + escapeHtml(productUrl) + '" class="sk-search-detail-card__main"' +
            ' id="predictive-search-option-product-1" role="option" aria-selected="false" tabindex="-1">' +
            '<div class="sk-search-detail-card__left">' +
            '<div class="sk-search-detail-card__image">' + imgHtml + '</div>' +
            '<div class="sk-search-detail-card__info">' +
            (p.partNumber ? '<div class="sk-search-detail-card__part-number"' +
                (p.collectionPrimaryColor ? ' style="color: var(' + escapeHtml(p.collectionPrimaryColor) + ')"' : '') +
                '>' + i18n('partNumber') + ': ' + escapeHtml(p.partNumber) + '</div>' : '') +
            '<div class="sk-search-detail-card__title">' + escapeHtml(p.title) + '</div>' +
            '</div>' +
            '</div>' +
            (specsHtml ? '<div class="sk-search-detail-card__right">' + specsHtml + '</div>' : '') +
            '</a></div>';
    }

    function buildNoResultsBlock() {
        return '<div class="sk-search-no-results">' +
            FORKLIFT_SVG +
            '<p class="sk-search-no-results__text">' + i18n('noResults') + '</p>' +
            '</div>';
    }

    function buildBottomBar(searchTerm, showScopeToggle) {
        let toggleHtml = '';
        if (showScopeToggle) {
            const allCls = 'sk-search-scope-btn' + (currentScope === 'all' ? ' is-active' : '');
            const colCls = 'sk-search-scope-btn' + (currentScope === 'collection' ? ' is-active' : '');
            toggleHtml =
                '<div class="sk-search-scope-toggle" role="group" aria-label="Search scope">' +
                '<button class="' + allCls + '" data-sk-scope="all" type="button">' + i18n('allProducts') + '</button>' +
                '<button class="' + colCls + '" data-sk-scope="collection" type="button">' + i18n('inThisCategory') + '</button>' +
                '</div>';
        }

        return '<div class="sk-search-bottom-bar">' +
            '<a href="' + escapeHtml(buildResultsPageUrl(searchTerm)) + '" class="sk-search-bottom-bar__link">' +
            i18n('seeAllResults') + ' &ldquo;' + escapeHtml(searchTerm) + '&rdquo;</a>' +
            toggleHtml +
            '</div>';
    }


    function buildDropdownMarkup(data, searchTerm) {
        const collections = data.collections || [];
        const products = data.products || [];
        const total = data.total;
        const col = getCurrentCollection();
        const query = searchTerm.trim();

        const hasCategories = collections.length > 0;
        const hasProducts = products.length > 0;
        const noResults = !hasCategories && !hasProducts;

        let contentHtml = '';
        const isPartNumber = isPartNumberQuery(query, total, products.length);

        if (isPartNumber) {
            contentHtml = buildPartNumberCard(products[0]);
        } else if (noResults) {
            contentHtml = buildNoResultsBlock();
        } else {
            const categoriesHtml = hasCategories
                ? '<h4 class="predictive-search__heading h6">' + i18n('categories') + '</h4>' +
                '<ul class="sk-search-category__list">' +
                collections.map(buildCategoryItem).join('') +
                '</ul>'
                : '';

            const productsHtml = hasProducts
                ? '<h4 class="predictive-search__heading h6">' + i18n('products') + '</h4>' +
                '<ul class="predictive-search__results-list" role="group">' +
                products.slice(0, 8).map(buildCompactProductCard).join('') +
                '</ul>'
                : '';

            if (hasCategories && hasProducts) {
                contentHtml =
                    '<div class="sk-search-results__col sk-search-results__col--full">' +
                    productsHtml +
                    '</div>' +
                    '<div class="sk-search-results__col sk-search-results__col--full sk-search-results__col--categories-bottom">' +
                    categoriesHtml +
                    '</div>';
            } else if (hasCategories) {
                contentHtml =
                    '<div class="sk-search-results__col sk-search-results__col--full">' +
                    categoriesHtml +
                    '</div>';
            } else {
                contentHtml =
                    '<div class="sk-search-results__col sk-search-results__col--full">' +
                    productsHtml +
                    '</div>';
            }
        }

        const bottomBarHtml = (noResults || isPartNumber) ? '' : buildBottomBar(searchTerm, !!col);

        const countText = total === 0
            ? i18n('noResults')
            : total + ' result' + (total !== 1 ? 's' : '');

        return '<div id="predictive-search-results" role="listbox">' +
            contentHtml +
            bottomBarHtml +
            '</div>' +
            '<span class="hidden" data-predictive-search-live-region-count-value>' + escapeHtml(countText) + '</span>';
    }


    function refreshSearch() {
        if (!lastQuery) return;

        predictiveSearchInstances = predictiveSearchInstances.filter(function (inst) {
            return inst.isConnected;
        });

        predictiveSearchInstances.forEach(function (inst) {
            try {
                if (inst.cachedResults) {
                    Object.keys(inst.cachedResults).forEach(function (k) {
                        if (k.indexOf('sk-') === 0) delete inst.cachedResults[k];
                    });
                }
                inst.getSearchResults(lastQuery);
            } catch (e) {
                console.error('[SK Search] Failed to refresh instance:', e);
            }
        });

        standaloneDropdownFetchers.forEach(function (entry) {
            if (entry.panel && !entry.panel.hasAttribute('hidden')) entry.fn(lastQuery);
        });
    }

    document.addEventListener('click', function (e) {
        const btn = e.target.closest('[data-sk-scope]');
        if (!btn) return;
        e.preventDefault();
        const newScope = btn.dataset.skScope;
        if (newScope === currentScope) return;
        currentScope = newScope;
        refreshSearch();
    });


    function patchPredictiveSearch() {
        const Cls = customElements.get('predictive-search');
        if (!Cls) return;

        const original = Cls.prototype.getSearchResults;

        Cls.prototype.getSearchResults = function (searchTerm) {
            if (!isApiReady()) return original.call(this, searchTerm);

            const self = this;
            lastQuery = searchTerm;

            if (predictiveSearchInstances.indexOf(this) === -1) {
                predictiveSearchInstances.push(this);
            }

            const queryKey = 'sk-' + currentScope + '-' + searchTerm.replace(/\s+/g, '-').toLowerCase();
            this.setLiveRegionLoadingState();

            if (this.cachedResults[queryKey]) {
                this.renderSearchResults(this.cachedResults[queryKey]);
                return;
            }

            if (self._skAbortCtrl) self._skAbortCtrl.abort();
            self._skAbortCtrl = new AbortController();

            const resultsContainer = self.querySelector('[data-predictive-search]');
            if (resultsContainer && resultsContainer.querySelector('#predictive-search-results')) {
                showLoadingOverlay(resultsContainer);
            } else {
                self.renderSearchResults(LOADING_SPINNER);
            }

            fetchSearchData(searchTerm, self._skAbortCtrl.signal)
                .then(function (data) {
                    const markup = buildDropdownMarkup(data, searchTerm);
                    if (self.allPredictiveSearchInstances) {
                        self.allPredictiveSearchInstances.forEach(function (inst) {
                            inst.cachedResults[queryKey] = markup;
                        });
                    } else {
                        self.cachedResults[queryKey] = markup;
                    }
                    if (resultsContainer && resultsContainer.querySelector('#predictive-search-results')) {
                        applyResultsWithTransition(resultsContainer, markup);
                    } else {
                        self.renderSearchResults(markup);
                    }
                })
                .catch(function (err) {
                    if (err && err.name === 'AbortError') return;
                    console.error('[SK Search] Fetch error (predictive):', err);
                    self.close();
                });
        };
    }


    function setupStandaloneDropdown(form) {
        const input = form.querySelector('input[type="search"]');
        if (!input) return;

        if (!input.value) {
            const urlQuery = new URLSearchParams(window.location.search).get('query');
            if (urlQuery) input.value = urlQuery;
        }

        const panel = document.createElement('div');
        panel.className = 'predictive-search predictive-search--header sk-standalone-dropdown';
        panel.setAttribute('tabindex', '-1');
        panel.setAttribute('hidden', '');
        form.appendChild(panel);

        let abortController = null;
        let debounceTimer = null;

        function openPanel() {
            panel.removeAttribute('hidden');
            input.setAttribute('aria-expanded', 'true');
        }

        function closePanel(clearContent) {
            panel.setAttribute('hidden', '');
            input.setAttribute('aria-expanded', 'false');
            if (abortController) {
                abortController.abort();
                abortController = null;
            }
            if (clearContent) {
                setTimeout(function () {
                    if (panel.hasAttribute('hidden')) panel.innerHTML = '';
                }, 250);
            }
        }

        let panelHasValidResults = false;

        function fetchAndRender(q) {
            if (abortController) abortController.abort();
            abortController = new AbortController();
            panelHasValidResults = false;

            const hasResults = panel.querySelector('#predictive-search-results');
            if (hasResults) {
                showLoadingOverlay(panel);
            } else {
                panel.textContent = '';
                const temp = document.createElement('div');
                temp.innerHTML = LOADING_SPINNER;
                while (temp.firstChild) panel.appendChild(temp.firstChild);
            }
            openPanel();

            fetchSearchData(q, abortController.signal)
                .then(function (data) {
                    const markup = buildDropdownMarkup(data, q);
                    panelHasValidResults = true;
                    if (hasResults) {
                        applyResultsWithTransition(panel, markup);
                    } else {
                        panel.textContent = '';
                        const t = document.createElement('div');
                        t.innerHTML = markup;
                        while (t.firstChild) panel.appendChild(t.firstChild);
                    }
                })
                .catch(function (err) {
                    if (err && err.name === 'AbortError') return;
                    console.error('[SK Search] Fetch error (standalone):', err);
                    closePanel(true);
                });
        }

        standaloneDropdownFetchers.push({fn: fetchAndRender, panel: panel});

        function onInputChange() {
            clearTimeout(debounceTimer);
            const q = input.value.trim();
            if (!q) {
                closePanel(true);
                return;
            }
            lastQuery = q;
            debounceTimer = setTimeout(function () {
                fetchAndRender(q);
            }, 300);
        }

        function onDocumentClick(e) {
            if (!form.contains(e.target) && !e.target.closest('[data-sk-scope]')) {
                closePanel(false);
            }
        }

        function onInputKeydown(e) {
            if (e.key === 'Escape') closePanel(false);
        }

        function onInputFocus() {
            const q = input.value.trim();
            if (q && panel.hasAttribute('hidden')) {
                if (panelHasValidResults) {
                    openPanel();
                } else {
                    fetchAndRender(q);
                }
            }
        }

        function onPageScroll() {
            if (!panel.hasAttribute('hidden')) {
                closePanel(false);
                input.blur();
            }
        }

        input.addEventListener('input', onInputChange);
        input.addEventListener('focus', onInputFocus);
        document.addEventListener('click', onDocumentClick);
        input.addEventListener('keydown', onInputKeydown);
        window.addEventListener('scroll', onPageScroll, {passive: true});
    }


    document.addEventListener('keydown', function (e) {
        if (e.key !== 'Enter' || !isApiReady()) return;
        const input = e.target;
        if (!input || input.type !== 'search') return;

        const form = input.closest('form');
        if (!form || form.hasAttribute('data-sk-results-form')) return;

        const ps = form.closest('predictive-search');
        const panel = ps
            ? ps.querySelector('[data-predictive-search]')
            : form.querySelector('.sk-standalone-dropdown');

        if (!panel || panel.hasAttribute('hidden')) return;

        if (panel.querySelector('[aria-selected="true"]')) return;

        const links = panel.querySelectorAll('a.predictive-search__item--link-with-thumbnail, a.sk-search-detail-card__main');
        if (links.length === 1) {
            e.preventDefault();
            e.stopImmediatePropagation();
            window.location.href = links[0].href;
        }
    }, true);

    function interceptFormSubmits() {
        document.querySelectorAll('form[role="search"]').forEach(function (form) {
            if (form.hasAttribute('data-sk-results-form')) return;

            form.addEventListener('submit', function (e) {
                if (!isApiReady()) return;
                const input = form.querySelector('input[type="search"]');
                const q = ((input && input.value) || '').trim();
                if (!q) return;
                e.preventDefault();
                window.location.href = buildResultsPageUrl(q);
            });
        });

        document.addEventListener('click', function (e) {
            if (!isApiReady()) return;
            const link = e.target.closest('.sk-search-bottom-bar__link');
            if (link) return;

            const btn = e.target.closest('.predictive-search__item--term');
            if (!btn) return;
            const container = btn.closest('predictive-search') || btn.closest('form[role="search"]');
            const input = container && container.querySelector('input[type="search"]');
            const q = ((input && input.value) || lastQuery || '').trim();
            if (!q) return;
            e.preventDefault();
            window.location.href = buildResultsPageUrl(q);
        });
    }


    function init() {
        if (!isApiReady()) return;

        customElements.whenDefined('predictive-search').then(patchPredictiveSearch);

        document.querySelectorAll('form[role="search"]').forEach(function (form) {
            if (!form.closest('predictive-search') && !form.hasAttribute('data-sk-results-form')) {
                setupStandaloneDropdown(form);
            }
        });

        interceptFormSubmits();
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }
})();
